import React from 'react';
import { store } from 'redux/store';
import { push } from 'connected-react-router';
import AccountImage from 'components/Image/AccountImage';
import DataTable from '../../../components/Table/DataTable';
import CurrencyText from '../../../components/TextHover/CurrencyText';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Logo",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    },
    {
        name: "Account",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Gross Profit",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => <CurrencyText currency="ZAR" value={value} popoverStyle={{ marginTop: -20 }} />,
            sortDirection: 'desc'
        }
    }
];

class AccountManagerGPTable extends React.Component {

    options = {
        onRowClick: (row) => store.dispatch(push('/customers/view/' + row[0]))
    };

    render() {
        return (
                <DataTable
                    title={"Account Details"}
                    data={
                        this.props.data
                        .map(stat => 
                            [
                                stat.account_id, 
                                <AccountImage company={stat.account_company} image={stat.account_image} />, 
                                stat.account_no + " " + stat.account_name, 
                                stat.total_gp
                            ]
                        )
                    }
                    columns={columns}
                    options={this.options}
                />
        );
    }
}

export default AccountManagerGPTable;
